import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { ConfirmationService } from 'primeng/api';
import { ConfirmPopup } from 'primeng/confirmpopup';
import { Configurazione } from '../../../shared/interface';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-configurazioni-backoffice',
  templateUrl: './configurazioni-backoffice.component.html',
  styleUrl: './configurazioni-backoffice.component.css'
})
export class ConfigurazioniBackofficeComponent implements OnInit {

  constructor(private apiService: ApiService, private confirmationService: ConfirmationService) {}

  @ViewChild("deleteConfigurazione") deleteConfigurazione!: ConfirmPopup;

  configurazioni: Configurazione[] = []
  loading: boolean = false;

  ngOnInit(): void {
    
    this.loading = true;

    this.apiService.setConfigurazioni();
    this.apiService.configurazioniChanged.subscribe({
      next: (data) => {
        this.configurazioni = [...data];
        this.loading = false;
      },
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),      
    })
  }

  onGlobalFilter(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  onOpenDeleteConfigurazione(event: Event, configurazione: Configurazione) {        
    this.confirmationService.confirm({      
      target: event.target as EventTarget,
      message: `Sei sicuro di voler eliminare la configurazione?`,
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deleteConfigurazione(configurazione.id).subscribe({          
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {  
            this.confirmationService.close()
            this.apiService.setConfigurazioni()
            this.apiService.message("success", "Eliminazione", "La configurazione è stata eliminata con successo")
          }
        })
      }
    });
  }

  onDeleteConfigurazione() {
    this.deleteConfigurazione.accept();
  }

  onAnnullaDeleteConfigurazione() {
    this.deleteConfigurazione.reject();
  }

}
